import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { userActions, sendActions } from '@/stores/action/home.action';
import UserInfor from './UserInfor';
import { toLocale, toNumber } from '@/utils/calculate.util';
import { getLocaleWordContent } from '@/utils/language.util';

const Form = ({ userid, qty, name, setName, setQty, handleChange, SendActions }) => {
    const sendBuy = (e) => {
        if (e) e.preventDefault();
        let parse_qty = toNumber(qty, 0);
        const params = { amount: parse_qty, deposit_name: name };
        SendActions.postSend(params).then((rsp) => {
            if (rsp === 1) {
                alert(getLocaleWordContent('입금요청완료입니다'));
                setName('');
                setQty('');
            } else {
                alert(rsp.msg);
            }
        });
    };
    
    //toLocale(info.toQty, info.qtyDspDecPnt)
    return (
        <form className="inputbox">
            <div className="input_form">
                <p className="title">ALEO {getLocaleWordContent('아이디')}</p>
                <input type="text" className="input01" defaultValue={userid || ''} required readOnly />
            </div>
            <div className="input_form">
                <p className="title">{getLocaleWordContent('입금 금액')}</p>
                <input
                    type="text"
                    name="qty"
                    value={toLocale(qty, 0) || ''}
                    onChange={(e) => handleChange(e, 'qty')}
                    className="input01"
                    required
                />
            </div>
            <div className="input_form">
                <p className="title">{getLocaleWordContent('입금자명')}</p>
                <input
                    type="text"
                    name="name"
                    value={name || ''}
                    onChange={(e) => handleChange(e, 'name')}
                    className="input01"
                    required
                />
            </div>
            <div className="sub_btn_box">
                <input type="button" defaultValue={getLocaleWordContent('요청하기')} className="btn01" onClick={sendBuy} />
            </div>
        </form>
    );
};

function SendCoin({ user, UserActions, SendActions }) {
    const [qty, setQty] = useState('');
    const [name, setName] = useState('');
    const history = useHistory();
    const fetchBusinesses = () => {
        UserActions.getUserBalance();
    };
    useEffect(fetchBusinesses, []);

    const handleChange = (e, name) => {
        if (e) e.preventDefault();

        if (name === 'qty') {
            setQty(e.target.value);
        } else if (name === 'name') {
            setName(e.target.value);
        }
    };
    const NextPage = (e, page) => {
        if (e) e.preventDefault();
        history.replace('/' + page);
    };

    return (
        <>
            <div className="bg_balance_left">
                <UserInfor />
                <div className="inner">
                    <div className="exchange">
                        <p className="orange2 box_coin">{getLocaleWordContent('10,000원 단위 입금 가능합니다')}</p>
                        <p className="orange2 box_coin">1KRW = 1p/s</p>
                    </div>
                </div>
                <div className="sp20"></div>
                <div className="log_box">
                    <h2 className="strong">p/s {getLocaleWordContent('포인트 교환 요청')}</h2>
                    <Form
                        userid={user.getIn(['id'])}
                        qty={qty}
                        name={name}
                        setQty={setQty}
                        setName={setName}
                        handleChange={handleChange}
                        SendActions={SendActions}
                    />
                    <div className="sp20"></div>
                    <div className="bottom-btn text-center">
                        <button className="b_orange btn02" onClick={(e) => NextPage(e, 'sphistory/?tab1')}>
                           {getLocaleWordContent('입금 내역')}
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}
export default connect(
    (state) => ({
        user: state.home.getIn(['user']),
    }),
    (dispatch) => ({
        UserActions: bindActionCreators(userActions, dispatch),
        SendActions: bindActionCreators(sendActions, dispatch),
    }),
)(SendCoin);
